import { Outlet, useLocation } from "react-router-dom";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { Topbar } from "./Topbar";
import { BottomNav } from "./BottomNav";
import { AnimatePresence } from "framer-motion";
import { PageTransition } from "./PageTransition";
import { CommandPalette } from "./CommandPalette";
import { OnboardingWidget } from "@/components/onboarding/OnboardingWidget";
import { useTenantBranding } from "@/hooks/useTenantBranding";
import { ImpersonationBanner } from "@/components/admin/ImpersonationBanner";
import { PlatformAnnouncementBanner } from "./PlatformAnnouncementBanner";
import { TrialExpiryBanner } from "./TrialExpiryBanner";
import { useLegalAcceptance } from "@/hooks/useLegalAcceptance";
import { LegalAcceptanceModal } from "@/components/legal/LegalAcceptanceModal";
import { PageLoader } from "@/components/common/PageLoader";

export function AppShell() {
  const location = useLocation();

  // Apply dynamic tenant branding (primary color) via CSS custom properties
  useTenantBranding();

  const { needsAcceptance, loading: legalLoading } = useLegalAcceptance();

  if (legalLoading) return <PageLoader />;
  if (needsAcceptance) return <LegalAcceptanceModal />;

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full flex-col min-w-0 overflow-hidden">
        <ImpersonationBanner />
        <div className="flex flex-1 min-w-0 w-full">
          {/* Desktop sidebar */}
          <AppSidebar />

          {/* Main content area */}
          <SidebarInset className="flex flex-col min-w-0 overflow-hidden">
            <Topbar />
            <PlatformAnnouncementBanner />
            <TrialExpiryBanner />
            <main data-route={location.pathname} className="flex-1 min-w-0 overflow-auto overflow-x-hidden">
              <AnimatePresence mode="wait">
                <PageTransition key={location.pathname}>
                  <Outlet />
                </PageTransition>
              </AnimatePresence>
            </main>
          </SidebarInset>

          {/* Mobile bottom navigation */}
          <BottomNav />

          {/* Global Command Palette (CMD+K) */}
          <CommandPalette />
          <OnboardingWidget />
        </div>
      </div>
    </SidebarProvider>
  );
}
